module.exports = __webpack_public_path__ + "img/isStar1.6fd38242.png";